// first function to be called
const verticalizePoemsAndTableLayouts = () => {
  if (typeof window === "undefined") return;

  const layoutdualColumns =
    window.document.querySelectorAll(".layoutdualColumn");
  const layoutPoems = window.document.querySelectorAll(".layoutPoem");
  const layoutImageInSides =
    window.document.querySelectorAll(".layoutImageInSide");

  if (layoutdualColumns != null) {
    for (let i = 0; i < layoutdualColumns.length; i++) {
      const layoutdualColumn = layoutdualColumns.item(i);
      const verticalizeTableElement = verticalizeTable(layoutdualColumn);

      if (verticalizeTableElement != null)
        layoutdualColumn.parentElement?.replaceChild(
          verticalizeTableElement,
          layoutdualColumn,
        );
    }
  }

  if (layoutPoems != null) {
    for (let i = 0; i < layoutPoems.length; i++) {
      const layoutPoem = layoutPoems.item(i);
      const verticalizeTableElement = verticalizeTable(layoutPoem);

      if (verticalizeTableElement != null)
        layoutPoem.parentElement?.replaceChild(
          verticalizeTableElement,
          layoutPoem,
        );
    }
  }

  if (layoutImageInSides != null) {
    for (let i = 0; i < layoutImageInSides.length; i++) {
      const layoutImageInSide = layoutImageInSides.item(i);
      const verticalizeTableElement = verticalizeTable(layoutImageInSide);

      if (verticalizeTableElement != null)
        layoutImageInSide.parentElement?.replaceChild(
          verticalizeTableElement,
          layoutImageInSide,
        );
    }
  }
};

const verticalizeTable = (tableElement: Element) => {
  const computedStyle = window.getComputedStyle(tableElement);

  if (
    "table" === computedStyle.display ||
    "TABLE" === tableElement.tagName.toUpperCase()
  ) {
    const tbodyElement = tableElement.firstElementChild;

    if (
      tbodyElement != null &&
      "TBODY" === tbodyElement.tagName.toUpperCase() &&
      tbodyElement.nextElementSibling == null
    ) {
      const tableDivElement =
        cloneTableElementToDivWithDisplayTable(tableElement);
      const trElement = tbodyElement.firstElementChild;

      if (
        trElement != null &&
        "TR" === trElement.tagName.toUpperCase() &&
        trElement.nextElementSibling == null
      ) {
        const tdElements = trElement.children;

        if (tdElements.length == 2) {
          // 2 column table
          if (
            "TD" === tdElements[0].tagName.toUpperCase() &&
            "TD" === tdElements[1].tagName.toUpperCase()
          ) {
            if (
              (tdElements[0].classList.contains("dualColumnFirstCell") &&
                tdElements[1].classList.contains("dualColumnSecondCell")) ||
              (tdElements[0].classList.contains("textCell") &&
                tdElements[1].classList.contains("pictureCell"))
            ) {
              const tableCellDiv =
                cloneTableRowElementToDivWithDisplayTableCell(trElement);
              const firstBlockDiv = cloneTableCellElementToDivWithDisplayBlock(
                tdElements[0],
              );
              const secondBlockDiv = cloneTableCellElementToDivWithDisplayBlock(
                tdElements[1],
              );

              tableCellDiv.appendChild(firstBlockDiv);
              tableCellDiv.appendChild(secondBlockDiv);
              tableDivElement.appendChild(tableCellDiv);

              return tableDivElement;
            }
          }
        } else if (tdElements.length == 3) {
          if (
            isPoemCell(tdElements[0]) &&
            isPoemCentralEmptyCell(tdElements[1]) &&
            isPoemCell(tdElements[2])
          ) {
            const firstVerseLines = getVerseLines(tdElements[0]);
            const secondVerseLines = getVerseLines(tdElements[2]);

            if (
              Boolean(firstVerseLines) &&
              firstVerseLines.length == secondVerseLines.length
            ) {
              for (let index = 0; index < firstVerseLines.length; index++) {
                const firstVerse = firstVerseLines[index];
                const secondVerse = secondVerseLines[index];
                const tableCellDiv =
                  cloneTableRowElementToDivWithDisplayTableCell(trElement);
                const firstBlockDiv =
                  cloneTableCellElementToDivWithDisplayBlock(
                    tdElements[0],
                    false,
                    false,
                  );
                const secondBlockDiv =
                  cloneTableCellElementToDivWithDisplayBlock(
                    tdElements[2],
                    false,
                    false,
                  );
                firstVerse.forEach((node) => {
                  firstBlockDiv.appendChild(node);
                });

                secondVerse.forEach((node) => {
                  secondBlockDiv.appendChild(node);
                });

                tableCellDiv.appendChild(firstBlockDiv);
                tableCellDiv.appendChild(secondBlockDiv);
                tableDivElement.appendChild(tableCellDiv);
              }
              return tableDivElement;
            } else {
              // poem with one couplet
              const tableCellDiv =
                cloneTableRowElementToDivWithDisplayTableCell(trElement);
              const firstBlockDiv = cloneTableCellElementToDivWithDisplayBlock(
                tdElements[0],
                false,
              );
              const secondBlockDiv = cloneTableCellElementToDivWithDisplayBlock(
                tdElements[2],
                false,
              );

              tableCellDiv.appendChild(firstBlockDiv);
              tableCellDiv.appendChild(secondBlockDiv);
              tableDivElement.appendChild(tableCellDiv);

              return tableDivElement;
            }
          }
        }
      } else if (trElement != null && "TR" === trElement.tagName.toUpperCase())
        return verticalizeMultiRowPoem(tableDivElement, trElement);
    }
  }

  return null;
};

const cloneTableElementToDivWithDisplayTable = (tableElement: Element) => {
  const createDivElement = document.createElement("div");
  const tableElementClass = tableElement.getAttribute("class");
  const tableElementStyle = tableElement.getAttribute("style");

  if (tableElementClass != null && tableElementClass !== "")
    createDivElement.setAttribute("class", tableElementClass);

  if (tableElementStyle != null && tableElementStyle !== "")
    createDivElement.setAttribute("style", tableElementStyle);

  createDivElement.style.display = "table";

  return createDivElement;
};

const cloneTableRowElementToDivWithDisplayTableCell = (trElement: Element) => {
  const tableCellDiv: HTMLElement = document.createElement("div");
  const tableCellClass = trElement.getAttribute("class");
  const tableCellStyle = trElement.getAttribute("style");

  if (tableCellClass != null && tableCellClass !== "")
    tableCellDiv.setAttribute("class", tableCellClass);
  if (tableCellStyle != null && tableCellStyle !== "")
    tableCellDiv.setAttribute("style", tableCellStyle);

  tableCellDiv.style.display = "table-row";

  return tableCellDiv;
};

const cloneTableCellElementToDivWithDisplayBlock = (
  element: Element,
  copyClass: boolean = true,
  deep: boolean = true,
) => {
  const firstBlockDiv = document.createElement("div");
  const firstBlockDivStyle = element.getAttribute("style");

  if (copyClass) {
    const firstBlockDivClass = element.getAttribute("class");

    if (firstBlockDivClass != null && firstBlockDivClass !== "")
      firstBlockDiv.setAttribute("class", firstBlockDivClass);
  }

  if (firstBlockDivStyle != null && "" !== firstBlockDivStyle)
    firstBlockDiv.setAttribute("style", firstBlockDivStyle);

  firstBlockDiv.style.display = "block";

  if (deep) {
    const childNodes = element.childNodes;
    for (let index = 0; index < childNodes.length; index++)
      firstBlockDiv.appendChild(childNodes.item(index).cloneNode(true));
  }

  return firstBlockDiv;
};

const getVerseLines = (container: Element): Node[][] => {
  const childNodes: NodeListOf<ChildNode> = container.childNodes;
  const verseLines: Node[][] = [];

  for (let index = 0; index < childNodes.length; index++) {
    const item = childNodes[index];

    if (item.nodeType === Node.ELEMENT_NODE) {
      const element = childNodes[index];

      if (element.nodeName && element.nodeName.toUpperCase() === "BR")
        verseLines.push([]);
      else {
        if (verseLines.length === 0) verseLines.push([]);

        const verse = verseLines[verseLines.length - 1];

        verse.push(item);
      }
    } else if (item.nodeType === Node.TEXT_NODE) {
      if (verseLines.length === 0) verseLines.push([]);

      const verse = verseLines[verseLines.length - 1];

      verse.push(item);
    }
  }

  return verseLines;
};

const verticalizeMultiRowPoem = (
  tableDivElement: Element,
  trElement: Element,
) => {
  const whileTrue = true;

  while (whileTrue) {
    const tableCellDiv: HTMLElement =
      cloneTableRowElementToDivWithDisplayTableCell(trElement);
    const tdElements = trElement.children;

    if (tdElements.length == 3) {
      if (
        isPoemCell(tdElements[0]) &&
        isPoemCentralEmptyCell(tdElements[1]) &&
        isPoemCell(tdElements[2])
      ) {
        const firstBlockDiv = cloneTableCellElementToDivWithDisplayBlock(
          tdElements[0],
          false,
          true,
        );
        const secondBlockDiv = cloneTableCellElementToDivWithDisplayBlock(
          tdElements[2],
          false,
          true,
        );

        tableCellDiv.appendChild(firstBlockDiv);
        tableCellDiv.appendChild(secondBlockDiv);

        tableDivElement.appendChild(tableCellDiv);
      }
    }

    if (trElement.nextElementSibling == null) break;
    else tableCellDiv.style.marginBottom = "10px";
  }
};

const isPoemCell = (element: Element) =>
  isTableCell(element) &&
  (element.classList.contains("poemCell") ||
    element.classList.contains("poemCellRight") ||
    element.classList.contains("poemCellLeft"));

const isPoemCentralEmptyCell = (element: Element) =>
  isTableCell(element) && element.classList.contains("poemCentralEmptyCell");

const isTableCell = (element: Element) => {
  const computedStyle = window.getComputedStyle(element);

  if (
    "table-cell" === computedStyle.display ||
    "TD" == element.tagName.toUpperCase() ||
    "TH" == element.tagName.toUpperCase()
  )
    return true;

  return false;
};

export default verticalizePoemsAndTableLayouts;
